import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import * as messageApi from '../../../api/messages';

const MessagesPage = () => {
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadMessages();
  }, []);

  const loadMessages = async () => {
    try {
      const data = await messageApi.getAllMessages();
      setMessages(data);
    } catch (error) {
      console.error('Error loading messages:', error);
      // You might want to add error handling UI here
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this message?')) {
      try {
        await messageApi.deleteMessage(id);
        await loadMessages();
      } catch (error) {
        console.error('Error deleting message:', error);
        // You might want to add error handling UI here
      }
    }
  };

  const handleDisplay = (message) => {
    setSelectedMessage(message);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedMessage(null);
  };

  const columns = [
    {
      name: 'Nom',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
    },
    {
      name: 'Telephone',
      selector: row => row.phone,
      sortable: true,
    },
    {
      name: 'Objet',
      selector: row => row.subject,
      sortable: true,
    },
    {
      name: 'Date',
      selector: row => row.createdAt ? new Date(row.createdAt).toLocaleDateString('fr-FR', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric'
      }) + ' ' + new Date(row.createdAt).toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
      }) : '',
      sortable: true,
      width: '140px',
      sortFunction: (a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateB - dateA; // Most recent first
      },
    },
    {
      name: 'Message',
      selector: row => row.message,
    },
    {
      name: 'Actions',
      cell: row => (
        <>
          <button
            onClick={() => handleDisplay(row)}
            className="btn btn-info btn-sm"
          >
            Afficher
          </button>
          <span style={{ margin: '0 10px' }}></span>
          <button
            onClick={() => handleDelete(row.id)}
            className="btn btn-danger btn-sm"
          >
            Supprimer
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="container pt-120">
      <h2>Messages</h2>
      <DataTable
        columns={columns}
        data={messages}
        pagination
        defaultSortField="createdAt"
        defaultSortAsc={false}
      />
      {showModal && selectedMessage && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Message Détails</h3>
            <form>
              <div className="form-group">
                <label>Nom</label>
                <input type="text" readOnly value={selectedMessage.name} className="form-control" />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" readOnly value={selectedMessage.email} className="form-control" />
              </div>
              <div className="form-group">
                <label>Téléphone</label>
                <input type="text" readOnly value={selectedMessage.phone || ''} className="form-control" />
              </div>
              <div className="form-group">
                <label>Objet</label>
                <input type="text" readOnly value={selectedMessage.subject} className="form-control" />
              </div>
              <div className="form-group">
                <label>Date</label>
                <input 
                  type="text" 
                  readOnly 
                  value={selectedMessage.createdAt ? new Date(selectedMessage.createdAt).toLocaleDateString('fr-FR', { 
                    day: 'numeric', 
                    month: 'long', 
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  }) : ''} 
                  className="form-control" 
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea 
                  readOnly 
                  value={selectedMessage.message} 
                  rows="10"
                  className="form-control"
                ></textarea>
              </div>
              <button type="button" onClick={handleModalClose} className="btn btn-secondary">Fermer</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessagesPage;
